import React, { ReactNode } from 'react'

interface IProps {
  cancelText?: ReactNode
  confirmText?: ReactNode
  onCancel?(): void
  onConfirm?(): void
}

const Confirm: React.FC<IProps> = ({
  confirmText,
  cancelText,
  children,
  onCancel,
  onConfirm,
}) => {
  return (
    <React.Fragment>
      <p className="tw-pb-12 tw-pt-8 tw-text-18 tw-font-medium">{children}</p>
      <div>
        <button
          type="button"
          className="tw-w-172 tw-h-36 tw-rounded-2 tw-border-1 tw-border-solid tw-border-video-gray"
          onClick={onCancel}
        >
          {cancelText || '取消'}
        </button>
        <button
          type="button"
          className="tw-w-172 tw-h-36 tw-rounded-2 tw-font-medium tw-bg-common-yellow tw-ml-8 hover:tw-bg-common-highlight-yellow"
          onClick={onConfirm}
        >
          {confirmText || '确认'}
        </button>
      </div>
    </React.Fragment>
  )
}

export default Confirm
